export default [
  {
    path: '/record/:record_id(\\w+)/detail',
    name: 'recorddetail',
    component: () => import('@/views/record/detail.vue')
  },
  {
    path: '/user/:user_id(\\w+)/record',
    name: 'userrecord',
    component: () => import('@/views/record/userrecord.vue')
  }
]
